import React from 'react';
import { Stack, Button, useTheme } from '@mui/material';


const NavigationTab = ({ tabs, activeTabId, activeTabName, onTabChange }) => {
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center" gap={2} px={4} pb={2}>
      {tabs?.map((tab) => (
        <Button
          key={tab.id}
          style={{
            color:  activeTabId === tab.id ? theme.palette.primary.main: theme.palette.common.black,
            borderBottom:
              activeTabId === tab.id ? `5px solid ${theme.palette.primary.main} ` : 'none',
            borderRadius: '2px',
            fontWeight: '500'
          }}
          onClick={() => onTabChange(tab.id, tab.name)}
        >
          {tab.name}
        </Button>
      ))}
    </Stack>
  );
};

export { NavigationTab };
